import React, { useEffect } from 'react'
import { AccordionItemLogic } from '../AccordionItemLogic/AccordionItemLogic.style'
import { eventTrackService } from 'shared/application/services/EventTrackService'

const AccordionContent = ({ children, isOpen, productType, ...props }) => {
  useEffect(() => {
    if (isOpen) {
      eventTrackService.track('content_display_interacted', {
        element_action: 'click',
        element_name: productType,
      })
    }
  }, [isOpen])
  return (
    <AccordionItemLogic isOpen={isOpen} {...props}>
      {isOpen && children}
    </AccordionItemLogic>
  )
}

export { AccordionContent }
